export default {
  TAB: 9,
  ENTER: 13,
  SPACE: 32,
  ESCAPE: 27,
  ARROW_UP: 38,
  ARROW_DOWN: 40,
  ARROW_RIGHT: 39,
  ARROW_LEFT: 37,
};
